/* eslint-disable camelcase */
import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';

import { JobContext } from 'context/jobContextContainer';
import { CallContext } from 'context/callContextContainer';
import {
  radiusApprovalRemainingSec,
  formatMinSec,
  radiusMilestoneLabel,
  RADIUS_APPROVAL_ANSWER_GRACE_SEC,
} from 'services/radiusApprovalService';

// Alert for drivers waiting on dispatch to approve a Pick Up / Drop Off tapped
// outside the base's radius. Rendered first in JobTableSection's BannerStack —
// a driver is waiting on it. No dismiss: the request leaves on its own when it
// is answered, cancelled by the driver, or the driver's wait runs out.
const RadiusApprovalBanner = () => {
  const { radiusApprovals, setRadiusApprovalModalInfo } = useContext(JobContext);
  const { basesSettings } = useContext(CallContext) || {};
  const [now, setNow] = useState(Date.now());

  const list = (Array.isArray(radiusApprovals) ? radiusApprovals : []).filter(
    r => radiusApprovalRemainingSec(r, now) > RADIUS_APPROVAL_ANSWER_GRACE_SEC
  );

  useEffect(() => {
    if (list.length === 0) return undefined;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [list.length > 0]);

  if (list.length === 0) {
    return null;
  }

  const lead = list[0];
  const label = radiusMilestoneLabel(lead);
  const where = lead.milestone === 'dropoff' ? 'drop-off' : 'pickup';
  const distance = lead.distance_m == null ? null : parseInt(lead.distance_m, 10);
  const extra = list.length - 1;

  return (
    <Banner>
      <div className="ra-banner-body">
        <div className="ra-banner-eyebrow">
          DRIVER WAITING FOR APPROVAL
          {lead.fetched_db && basesSettings?.[lead.fetched_db]?.base_name ? ` · ${basesSettings[lead.fetched_db].base_name.toUpperCase()}` : ''}
        </div>
        <div className="ra-banner-title">
          {distance != null
            ? `Job #${lead.job_id} — ${label} ${distance} m from the ${where} address`
            : lead.tap_lat != null
              ? `Job #${lead.job_id} — ${label} outside the ${where} area`
              : `Job #${lead.job_id} — ${label} with no GPS location`}
        </div>
        <div className="ra-banner-more">
          {`${lead.driver_name ? `Driver ${lead.driver_name} · ` : ''}can proceed without approval in ${formatMinSec(radiusApprovalRemainingSec(lead, now))}`}
          {extra > 0 ? ` · +${extra} more waiting` : ''}
        </div>
      </div>
      <Button variant="contained" onClick={() => setRadiusApprovalModalInfo(lead)} className="ra-banner-btn">
        Review
      </Button>
    </Banner>
  );
};

export default RadiusApprovalBanner;

const Banner = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 420px;
  max-width: 100%;
  padding: 14px 20px;
  border-radius: 12px;
  background: #0d1b2a;
  color: #e8eef5;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.35);
  border-left: 5px solid #f5b301;

  .ra-banner-eyebrow {
    font-size: 11px;
    letter-spacing: 1.5px;
    font-weight: 700;
    color: #f5b301;
  }
  .ra-banner-title {
    font-size: 17px;
    font-weight: 700;
    margin-top: 2px;
  }
  .ra-banner-more {
    font-size: 12px;
    color: #8aa0b6;
    margin-top: 2px;
  }
  .ra-banner-body {
    flex: 1;
  }
  .ra-banner-btn {
    background: #2f6df6;
    color: #fff;
    white-space: nowrap;
  }
`;
